exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.configuration-header {\n    min-width: 200px;\n}\n.action-button {\n    margin-bottom: 5px;\n}\n", ""]);

// exports
